module.exports = __webpack_public_path__ + "static/r1-14a991d9bf59179adff254e7fb959869.jpg";